// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import type { ITheme, IVerticalDividerClassNames } from "@fluentui/react";
// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import { memoizeFunction, mergeStyleSets } from "@fluentui/react";

import {
  commonHighContrastNoAdjustStyles,
  getDividerClassNames,
} from "@1js/acui-common";

export const getSectionDividerClassNames = memoizeFunction(
  (theme: ITheme): IVerticalDividerClassNames => {
    return mergeStyleSets(getDividerClassNames(theme), {
      divider: [
        {
          // Shorten the divider so it has 4px above and below
          height: "calc(100% - 8px)",
        },
        "ribbon-vertical-divider",
        commonHighContrastNoAdjustStyles,
      ],
      wrapper: {
        padding: "0 4px",
      },
    });
  }
);

export const getRowDividerClassNames = memoizeFunction(
  (theme: ITheme): IVerticalDividerClassNames => {
    return mergeStyleSets(getDividerClassNames(theme), {
      divider: [
        {
          // Shorten the divider so it has 2px above and below
          height: "calc(100% - 4px)",
        },
        commonHighContrastNoAdjustStyles,
        "ribbon-row-divider",
      ],
      wrapper: {
        padding: "0 4px",
      },
    });
  }
);

export const vNextStackTokens = { childrenGap: "2 0" };
